export const CLAUDE_MODEL_OPTIONS = [
  { value: 'claude-fable-5-1', label: 'Claude Fable 5.1' },
  { value: 'claude-opus-5-5', label: 'Claude Opus 5.5' },
  { value: 'claude-sonnet-5-5', label: 'Claude Sonnet 5.5' },
  { value: 'claude-haiku-5-5', label: 'Claude Haiku 5.5' },
  { value: 'claude-3-7-sonnet', label: 'Claude 3.7 Sonnet' },
  { value: 'claude-3-5-sonnet', label: 'Claude 3.5 Sonnet' },
  { value: 'claude-3-opus', label: 'Claude 3 Opus' },
  { value: 'claude-3-5-haiku', label: 'Claude 3.5 Haiku' },
  { value: 'claude-3-haiku', label: 'Claude 3 Haiku' }
];

export const GEMINI_MODEL_OPTIONS = [
  { value: 'gemini-3-8-flash', label: 'Gemini 3.8 Flash' },
  { value: 'gemini-3-5-flash', label: 'Gemini 3.5 Flash' },
  { value: 'gemini-3-5-flash-lite', label: 'Gemini 3.5 Flash Lite' },
  { value: 'gemini-3-1-pro-preview', label: 'Gemini 3.1 Pro (preview)' },
  { value: 'gemini-2.0-flash', label: 'Gemini 2.0 Flash' },
  { value: 'gemini-1.5-pro', label: 'Gemini 1.5 Pro' },
  { value: 'gemini-1.5-flash', label: 'Gemini 1.5 Flash' }
];
